import React, { Component } from 'react';
import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";
import CircularProgress from '@mui/material/CircularProgress';
import {
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    Paper,
    TableRow,
} from "@mui/material";
import CommonIcon from '../../../helpers/icons';
import Pagination from '@mui/material/Pagination';
import IconButton from '@mui/material/IconButton';
import ArrowLeft from '@mui/icons-material/ArrowLeft';
import ArrowRight from '@mui/icons-material/ArrowRight';

class TeamsListView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasVerticalScrollbar: false,
            page: Number(this.props.currentPage ? this.props.currentPage : 1),
            rowsPerPage: Number(this.props.pagesize ? this.props.pagesize : 10),

        }

        console.log(this.props.currentPage);

        this.tableRef = React.createRef();
        this.scrollTimeout = null;
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        this.tableRef.current.addEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            const table = this.tableRef.current;
            if (this.tableRef.current.scrollTop + this.tableRef.current.clientHeight >= table.scrollHeight - 50) {
                this.props.handleScroll()
            }
        }, 200);

    }
    componentDidUpdate
        (prevProps) {
        if (this.tableRef.current) {
            const element = this.tableRef.current;
            const hasVerticalScrollbar = element.scrollHeight > element.clientHeight;
            if (this.state.hasVerticalScrollbar !== hasVerticalScrollbar) {
                this.setState({ hasVerticalScrollbar });
            }
        }
        if (prevProps.pagesize != this.props.pagesize) {
            this.setState({ rowsPerPage: Number(this.props.pagesize) })
        }
    }
    handleChangePage = (event, newPage) => {
        const zeroBasedPage = newPage
        this.setState({ page: zeroBasedPage }, () => {
            this.props.paginatedData(zeroBasedPage);
        });
    };
    handleChangeRowsPerPage = (event) => {

        const newRowsPerPage = parseInt(event.target.value, 10);
        const newPageCount = Math.ceil(this.props.totalpages / newRowsPerPage);
        const newPage = Math.min(this.state.page, newPageCount - 1);

        this.setState({
            rowsPerPage: newRowsPerPage,
            page: newPage,
        }, () => {
            this.props.rowPerPage(newRowsPerPage);
            // this.props.paginatedData(newPageCount);
        });
    };

    render() {
        const columnHeaders = this.props?.columns;
        const sortConfig = this.props?.sortConfig;
        const normalData = this.props?.value || [];
        const { page, rowsPerPage } = this.state;
        // console.log(sortConfig);
        const isLoader = this.props?.isLoader;

        return (
            <div className='table-wrapper'>
                <TableContainer component={Paper} className={`table_change removeborder plr mr-scroll mb-3`} sx={{
                    maxHeight: '80% !important',
                    width: '100% !important', // Use 100% instead of -webkit-fill-available for consistency
                    minWidth: '100% !important',
                    marginTop: 0 // Adjusted min-width if you want full width
                }} ref={this.tableRef}>
                    <Table className={`tableborder ${this.state.hasVerticalScrollbar ? "normalwidth" : "scrolerwidth"}`} stickyHeader aria-label="sticky table">
                        <TableHead sx={{ position: "sticky", top: 0, zIndex: 1, "& .MuiTableCell-root": { backgroundColor: "background.paper" }, }}>
                            <TableRow className="tabel-head">
                                {columnHeaders.map((column) => (
                                    <TableCell className="table-header-padding " key={column.key} size='small'>
                                        <TableSortLabel
                                            className="table_label"
                                            active={sortConfig.SortBy === column.key}
                                            direction={
                                                sortConfig.sortByOrder
                                            }
                                            onClick={() => this.props?.handleSort(column.key)}
                                        >
                                            {column.label}
                                        </TableSortLabel>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isLoader ?
                                <TableRow>
                                    <TableCell colSpan={columnHeaders.length + 1} className="group-header mt-3 text-center" align="center">
                                        <CircularProgress color="primary" className="text-center" />
                                    </TableCell>
                                </TableRow>
                                :
                                (normalData.length > 0) ? (

                                    <>
                                        {normalData.map((row) => (


                                            <TableRow key={row.id}>
                                                {columnHeaders.map((column) => (
                                                    <TableCell className="table-cell-padding" key={column.key}>
                                                        {column.key === "action" ? (
                                                            <span className='cursor-pointer' onClick={() => this.props.handledeletemember(row.userId, row.email)}>
                                                                <CommonIcon fileName={'DeleteIcon'} />
                                                            </span>
                                                        ) : (
                                                            row[column.key] // ✅ Fixed this part by removing extra `{}` 
                                                        )}
                                                    </TableCell>
                                                ))}

                                            </TableRow>
                                        ))}
                                        {isLoader && (
                                            <TableRow className='border-no'>
                                                <TableCell colSpan={columnHeaders.length + 1} className="group-header mt-3 text-center" align="center">
                                                    <CircularProgress color="primary" className="text-center" />
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </>
                                ) : (
                                    (isLoader) ? (
                                        <TableRow>
                                            <TableCell colSpan={columnHeaders.length + 1} className="group-header mt-3 text-center" align="center">
                                                <CircularProgress color="primary" className="text-center" />
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        <TableRow className='border-no'>
                                            <TableCell colSpan={columnHeaders.length + 1} className="group-header mt-3 text-center" align="center">
                                                No records to display
                                            </TableCell>
                                        </TableRow>
                                    )
                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                {this.state.hasVerticalScrollbar && (
                    <div className="border-bottom"></div>
                )}
                <div className="ps-1 w-100 d-flex justify-content-between">
                    {/* Rows per page selector */}
                    <div className="">
                        <select

                            value={rowsPerPage}
                            onChange={this.handleChangeRowsPerPage}
                            style={{ fontSize: '14px', padding: '4px', outline: 'none', border: '1px solid #e8e8e8' }}
                        >
                            {[2, 5, 10, 25].map(size => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </select>
                    </div>
                    {/* Pagination controls */}
                    <div className="">
                        <Pagination
                            count={this.props.totalpages} // Total pages
                            page={this.props.currentPage} // 1-based page number
                            onChange={this.handleChangePage}
                            siblingCount={0} // Adjust as needed
                            boundaryCount={1} // Show boundary pages
                            shape="rounded"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default TeamsListView;
